import { CardContentPairBox, CardContentPair } from './cardContentPairBox.js';
export { CardContentPairBox, CardContentPair };
